module.exports = __webpack_public_path__ + "static/img/rotate11.802b6aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/horse/rotate11.png
// module id = s2zX
// module chunks = 1